<template>
  <v-layout justify-center>
    <v-dialog
        v-model="dialog_bloqueo"
        persistent
        width="300"
    >
      <v-card class="text-xs-center">
        <v-toolbar dark color="warning">
          <v-toolbar-title>
            {{$t('aviso')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <h2>{{$t('pagina_caduca')}}</h2>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
              color="primary"
              medium
              to="/home"
          >
            <v-icon left>home</v-icon>
            {{$t('inicio')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogSuccess"
        persistent
        width="300"
    >
      <v-card class="text-xs-center">
        <v-toolbar dark color="success">
          <v-toolbar-title>
            {{$t('aviso')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <h2>{{$t('survey_success')}}</h2>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
              color="primary"
              large
              to="/home"
          >
            <v-icon left>home</v-icon>
            {{$t('inicio')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 sm10 md8>
      <v-card class="text-xs-justify">
        <v-toolbar color="primary" dark>
          <v-icon>masks</v-icon><v-toolbar-title>{{$t('header_survey')}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
                {{$t('top1_survey')}}
          <br><br>
                {{$t('top2_survey')}}
          <br>
          <br>
          <v-divider></v-divider>
          <br>
          <v-layout row wrap>
            <v-flex xs12>
              <div>
                <strong>{{$t('question1')}}</strong>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-radio-group v-model="row1" row>
                <v-radio small :label="$t('Si')" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <div>
                <strong>{{$t('question2')}}</strong>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-radio-group v-model="row2" row>
                <v-radio small :label="$t('Si')" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <div>
                <strong>{{$t('question3')}}</strong>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-radio-group v-model="row3" row>
                <v-radio small :label="$t('Si')" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <div>
                <strong>{{$t('question4')}}</strong>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-radio-group v-model="row4" row>
                <v-radio small :label="$t('Si')" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <br>
                {{$t('below_survey')}}
          <br><br>
          <strong class="text-xs-centers">{{$t('msg_below_survey')}}</strong><br><br>
          <strong>{{$t('nombre')}}: </strong>{{name}}
          <br>
          <strong>{{$t('Fecha')}}: </strong>{{dd}}/{{mm}}/{{yyyy}}
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-alert :value="contestado" type="error" class="black--text">
            {{$t('msg_error_survey')}}
          </v-alert>
          <v-btn v-show="!contestado" @click="send" :loading="loading" block color="primary">{{$t('enviar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "healthy_format",
  data(){
    return{
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      loading: false,
      dd: null,
      mm: null,
      yyyy: null,
      dialog_bloqueo: false,
      dialogSuccess: false,
      name: '',
      contestado: false
    }
  },
  created() {
    this.get_current_date()
    this.getInfo()
  },
  watch: {
    row1 (value) {
      this.contestado = value || this.row2 || this.row3 || this.row4
    },
    row2 (value) {
      this.contestado = this.row1 || value || this.row3 || this.row4
    },
    row3 (value) {
      this.contestado = this.row1 || this.row2 || value || this.row4
    },
    row4 (value) {
      this.contestado = this.row1 || this.row2 || this.row3 || value
    }
  },
  methods: {
    send () {
      this.loading = true
      const config = {
        method: 'PATCH',
        url: 'https://empresa-service.intrare.app/empresas/health_survey/answered/' + this.$route.params['token'],
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
          .then(ok => {
            this.loading = false
            setTimeout(this.clear, 100)
          })
          .catch(error => {
            this.loading = false
          })
    },
    get_current_date: function (){
      var today = new Date()
      this.dd = today.getDate()
      this.mm = today.getMonth()+1
      this.yyyy = today.getFullYear()

      if(this.dd<10)
      {
        this.dd='0'+this.dd
      }

      if(this.mm<10)
      {
        this.mm='0'+this.mm
      }
      today = this.yyyy + '-' + this.mm + '-' + this.dd
      return today
    },
    getInfo(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/get_inv/health_survey/' + this.$route.params['token'],
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
          .then(response => {
            this.info = response.data
            if(response.data.length !== 0){
              console.log(response.data[0].status_survey)
              this.name = response.data[0].guest
              if (response.data[0].status_survey === 2) {
                this.dialogSuccess = true
              }
            }
            if(response.status == 204) {
              this.dialog_bloqueo = true
              console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
              console.log('Sin Datos')
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    clear () {
      location.reload()
    }
  }
}
</script>

<style scoped>

</style>